import React, { useState } from "react";

function App() {

  const [chars, setChars] = useState(
    ["", "", "", "", "", ""]
  );

  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const API_BASE =
    "https://api.farmfox.co/farmfox/supplier/lot";

  const handleChange = (
    value,
    index
  ) => {

    const val =
      value.toUpperCase();

    const newChars =
      [...chars];

    newChars[index] = val;

    setChars(newChars);

    if (
      val.length === 1 &&
      index < 5
    ) {

      document
        .getElementById(
          `box-${index + 1}`
        )
        .focus();

    }

  };

  const handleKeyDown = (
    e,
    index
  ) => {

    if (
      e.key === "Backspace" &&
      chars[index] === "" &&
      index > 0
    ) {

      document
        .getElementById(
          `box-${index - 1}`
        )
        .focus();

    }

  };

  const verifyLot = async () => {

    const lotNo =
      chars.join("");

    if (lotNo.length !== 6) {

      setError(
        "Enter all 6 characters"
      );

      return;

    }

    setLoading(true);
    setError("");
    setData(null);

    try {

      const response =
        await fetch(
          `${API_BASE}?lotNo=${lotNo}`
        );

      if (!response.ok) {

        throw new Error(
          "Lot not found"
        );

      }

      const result =
        await response.json();

      setData(result);

    } catch (err) {

      setError(
        "Invalid Lot Number"
      );

    } finally {

      setLoading(false);

    }

  };

  return (

    <div style={styles.page}>

      <div style={styles.container}>

        <h2 style={styles.brand}>
          farmfox.co
        </h2>

        <h3>
          Code Verification
        </h3>

        <p>
          Please enter first six
          characters of the batch
          number printed on the pack
        </p>

        <div style={styles.inputRow}>

          {chars.map(
            (char, index) => (

              <input
                key={index}
                id={`box-${index}`}
                maxLength="1"
                value={char}

                style={styles.box}

                onChange={(e) =>
                  handleChange(
                    e.target.value,
                    index
                  )
                }

                onKeyDown={(e) =>
                  handleKeyDown(
                    e,
                    index
                  )
                }
              />

            )
          )}

        </div>

        <button
          style={styles.button}
          onClick={verifyLot}
        >
          VERIFY AND PROCESS
        </button>

        {loading && (
          <p>Processing...</p>
        )}

        {error && (
          <p style={styles.error}>
            {error}
          </p>
        )}

        {data && (

          <div style={styles.card}>

            <p>
              <b>MARKETED BY:</b>
            </p>

            <p>
              <b>
                {data.companyName}
              </b>
            </p>

            <p>
              {data.companyAddress}
            </p>

            <p>
              <b>lot number: </b>
              {data.lotNo}
            </p>

            <p>
              <b>mfg Date: </b>
              {data.mfgDate}
            </p>

            <p>
              <b>manufactured by: </b>
              {data.manufacturedBy}
            </p>

            <p>
              <b>manufacturer address: </b>
              {data.manufacturerAddress}
            </p>

            <p>
              <b>fssai license no: </b>
              {data.fssaiLicenseNo}
            </p>
          </div>

        )}

      </div>

    </div>

  );

}

const ORANGE = "#ff4d1f";

const styles = {

  page: {
    fontFamily: "Arial",
    backgroundColor: "#f4f6f8",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  container: {
    width: "360px",
    padding: "25px",
    background: "white",
    borderRadius: "12px",
    boxShadow:
      "0 2px 8px rgba(0,0,0,0.2)",
    textAlign: "center"
  },

  brand: {
    color: ORANGE,
    fontWeight: "bold"
  },

  inputRow: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    marginTop: "15px"
  },

  box: {
    width: "38px",
    height: "38px",
    fontSize: "18px",
    textAlign: "center",
    borderRadius: "6px",
    border: `2px solid ${ORANGE}`
  },

  button: {
    marginTop: "20px",
    width: "100%",
    padding: "12px",
    backgroundColor: ORANGE,
    color: "white",
    border: "none",
    fontSize: "15px",
    borderRadius: "8px",
    cursor: "pointer"
  },

  card: {
    marginTop: "20px",
    padding: "15px",
    border: `2px solid ${ORANGE}`,
    borderRadius: "10px",
    textAlign: "left"
  },

  error: {
    color: "red",
    marginTop: "10px"
  }

};

export default App;